// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Campaign Rules Tab CSS Module
 * Styles for campaign rules and information display
 */
.ldfzFuewj_yIVukk5Fru {
  width: 100%;
  max-width: var(--campaign-tab-width);
  margin: 0 auto 10px;
  flex: 1;
  overflow-y: auto;
}
.YsZWBTc9tgYyQ0vw2iGQ {
  height: 200px;
  width: 100%;
  position: relative;
  display: block;
}
.R9NTRiJe4wu6tcU9uHOe {
  border-radius: 12px;
  overflow: hidden;
  padding: 1px;
}
.ysCgAconr8wjSqmhxKT8 {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 14px;
  background-color: #212121;
  border-radius: 12px;
  visibility: visible;
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(39, 39, 39, 0.5);
  box-sizing: border-box;
}
.pZptjcEJguq9e5YGrrwx {
  color: #d4d4d4;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: left;
  letter-spacing: 0.18px;
  gap: 14px;
  font-size: 21px;
  width: 90%;
  height: auto;
  line-height: 1.3;
}
.pZptjcEJguq9e5YGrrwx > div:first-child .BaZf1tzfHnGXWmkxFji5 {
  margin-top: -7px;
}
.BaZf1tzfHnGXWmkxFji5 {
  font-weight: bold;
}
.qMFk1s9W3fIMEfY4Be0k {
  font-weight: bold;
  color: #FFDF1A;
}
.HQgvqYw2jzMsa4NgOw7R {
  list-style-type: disc;
  padding-left: 1.25rem;
  margin: 0;
}
.UEER3lrcUBLLNRXXPTB6 {
  margin-bottom: 0;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .ysCgAconr8wjSqmhxKT8 {
    padding: 8.5px;
  }
  .pZptjcEJguq9e5YGrrwx {
    font-size: 15px;
  }
  .pZptjcEJguq9e5YGrrwx > div:first-child .BaZf1tzfHnGXWmkxFji5 {
    margin-top: -5px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (orientation: portrait) and (max-color:2147477350) {
  .ysCgAconr8wjSqmhxKT8,
  .R9NTRiJe4wu6tcU9uHOe {
    border-radius: 8px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (orientation: portrait) and (color:2147477350) {
  .ysCgAconr8wjSqmhxKT8,
  .R9NTRiJe4wu6tcU9uHOe {
    border-radius: 8px;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/prizePop/tabs/RulesTab/RulesTab.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;EACvC,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;AAAA;EACE;;IAEE,kBAAkB;EACpB;AACF;AAAA;AALA;AAAA;AAAA;AAAA;EACE;;IAEE,kBAAkB;EACpB;AACF;AAAA;AAAA;AAAA","sourcesContent":["/**\n * Campaign Rules Tab CSS Module\n * Styles for campaign rules and information display\n */\n.rulesWrapper {\n  width: 100%;\n  max-width: var(--campaign-tab-width);\n  margin: 0 auto 10px;\n  flex: 1;\n  overflow-y: auto;\n}\n.loaderContainer {\n  height: 200px;\n  width: 100%;\n  position: relative;\n  display: block;\n}\n.contentContainerWrapper {\n  border-radius: 12px;\n  overflow: hidden;\n  padding: 1px;\n}\n.contentContainer {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 14px;\n  background-color: #212121;\n  border-radius: 12px;\n  visibility: visible;\n  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.5);\n  border: 1px solid rgba(39, 39, 39, 0.5);\n  box-sizing: border-box;\n}\n.textSection {\n  color: #d4d4d4;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  text-align: left;\n  letter-spacing: 0.18px;\n  gap: 14px;\n  font-size: 21px;\n  width: 90%;\n  height: auto;\n  line-height: 1.3;\n}\n.textSection > div:first-child .title {\n  margin-top: -7px;\n}\n.title {\n  font-weight: bold;\n}\n.highlightedText {\n  font-weight: bold;\n  color: #FFDF1A;\n}\n.timeSlotList {\n  list-style-type: disc;\n  padding-left: 1.25rem;\n  margin: 0;\n}\n.timeSlotItem {\n  margin-bottom: 0;\n}\n@media (--campaign-mobile) {\n  .contentContainer {\n    padding: 8.5px;\n  }\n  .textSection {\n    font-size: 15px;\n  }\n  .textSection > div:first-child .title {\n    margin-top: -5px;\n  }\n}\n@media (orientation: portrait) and (--campaign-mobile) {\n  .contentContainer,\n  .contentContainerWrapper {\n    border-radius: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rulesWrapper": `ldfzFuewj_yIVukk5Fru`,
	"loaderContainer": `YsZWBTc9tgYyQ0vw2iGQ`,
	"contentContainerWrapper": `R9NTRiJe4wu6tcU9uHOe`,
	"contentContainer": `ysCgAconr8wjSqmhxKT8`,
	"textSection": `pZptjcEJguq9e5YGrrwx`,
	"title": `BaZf1tzfHnGXWmkxFji5`,
	"highlightedText": `qMFk1s9W3fIMEfY4Be0k`,
	"timeSlotList": `HQgvqYw2jzMsa4NgOw7R`,
	"timeSlotItem": `UEER3lrcUBLLNRXXPTB6`
};
export default ___CSS_LOADER_EXPORT___;
